const RenderInputForm = ({
  setDomain,
  domain,
  tld,
  record,
  setRecord,
  mintDomain,
  network,
  switchNetwork,
  editing,
  loading,
  setEditing,
  setLoading,
  updateDomain,
}) => {
  if (network !== "Polygon Mumbai Testnet") {
    return (
      <div className="connect-wallet-container">
        <h2>Please switch to Polygon Mumbai Testnet</h2>
        {/* This button will call our switch network function */}
        <button className="cta-button mint-button" onClick={switchNetwork}>
          Click here to switch
        </button>
      </div>
    );
  }

  return (
    <div className="form-container">
      <div className="first-row">
        <input
          type="text"
          value={domain}
          placeholder="domain"
          onChange={(e) => setDomain(e.target.value)}
        />
        <p className="tld"> {tld} </p>
      </div>

      <input
        type="text"
        value={record}
        placeholder="whats kind of bird are you?"
        onChange={(e) => setRecord(e.target.value)}
      />
      {editing ? (
        <div className="button-container">
          {/* This will call the updateDomain function we just made */}
          <button
            className="cta-button mint-button"
            disabled={loading}
            onClick={updateDomain}
          >
            Set record
          </button>
          {/* This will let us get out of editing mode by setting editing to false */}
          <button
            className="cta-button mint-button"
            onClick={() => {
              setEditing(false);
            }}
          >
            Cancel
          </button>
        </div>
      ) : (
        // If editing is not true, the mint button will be returned instead
        <button
          className="cta-button mint-button"
          disabled={loading}
          onClick={() => mintDomain()}
        >
          Mint
        </button>
      )}

      {/* <div className="button-container">
        <button
          className="cta-button mint-button"
          disabled={null}
          onClick={() => mintDomain()}
        >
          Mint
        </button>
        <button
          className="cta-button mint-button"
          disabled={null}
          onClick={null}
        >
          Set data
        </button>
      </div> */}
    </div>
  );
};

export default RenderInputForm;
